//internal
import Hero from "../Components/Hero";
import BaseLayout from "../Layout/BaseLayout";
import CatregoryList from "../Components/CatregoryList";
import OurProperty from "../Components/OurProperty";
import OurBrand from "../Components/OurBrand";
import Faq from "../Components/Faq";
import LastArticles from "../Components/LastArticles";
import Home from "../Components/Home";

export default function HomePAge() {
  return (
    <BaseLayout>
      <Home />
      <div>
        <Hero />
        <div className="hidden md:block">
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        <CatregoryList />
        <br />
        <br />
        <br />

        <OurProperty />
        <div className="hidden lg:block">
          <br />
          <br />
          <br />
          <br />
        </div>
        <OurBrand />
        <div className="hidden lg:block">
          <br />
          <br />
          <br />
          <br />
        </div>
        <LastArticles />
        <div className="hidden lg:block">
          <br />
          <br />
        </div>
        <Faq />
      </div>
    </BaseLayout>
  );
}
